<template>
  <div class="d-flex align-items-baseline boardview-shimmer">
    <div class="columns-wrapper">
      <div class="board-column">
        <div class="card shine"></div>
      </div>
      <div class="board-column">
        <div class="card shine"></div>
      </div>
      <div class="board-column">
        <div class="card shine"></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * This is the shimmer loader for BoardView
 */
export default {
  name: 'BoardShimmer'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/components/_board.scss';
.card {
  height: 130px;
  width: 100%;
  background-size: 800px 200px;
  border-radius: 10px;
  background-color: $documentColor;
  background-image: linear-gradient(
    to right,
    $documentColor 0%,
    #f4f4f7 20%,
    #f3f6f9 40%,
    #e8e8e8 100%
  );
}
.board-column {
  padding: 0 10px 35px 10px;
  .card:first-child {
    margin-top: 37px;
  }
}
</style>
